var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcadeGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.41775 16 4.87103 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346627 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153722C7.99113 -0.154961 9.59966 0.00346661 11.0615 0.608968C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8C16 9.05058 15.7931 10.0909 15.391 11.0615C14.989 12.0321 14.3997 12.914 13.6569 13.6569C12.914 14.3997 12.0321 14.989 11.0615 15.391C10.0909 15.7931 9.05058 16 8 16ZM8 1.6C6.7342 1.6 5.49683 1.97536 4.44435 2.6786C3.39188 3.38184 2.57157 4.38138 2.08717 5.55083C1.60277 6.72028 1.47603 8.0071 1.72298 9.24858C1.96992 10.4901 2.57946 11.6304 3.47452 12.5255C4.36958 13.4205 5.50995 14.0301 6.75142 14.277C7.9929 14.524 9.27973 14.3972 10.4492 13.9128C11.6186 13.4284 12.6182 12.6081 13.3214 11.5557C14.0246 10.5032 14.4 9.2658 14.4 8C14.4 6.30262 13.7257 4.67475 12.5255 3.47452C11.3253 2.27429 9.69739 1.6 8 1.6Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1996 8H9.59961V6.4H11.1996V8Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00039 8H6.40039V6.4H8.00039V8Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 4.7998H8V3.19981H9.6V4.7998Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcadeGames);
export default __webpack_public_path__ + "static/media/arcade-games.36e66f0efe2d4e7c6bc3bea906fbff4a.svg";
export { ForwardRef as ReactComponent };